var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#242D3E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 9C33.8366 9 41 16.1634 41 25C41 33.8366 33.8366 41 25 41C16.1634 41 9 33.8366 9 25C9 16.1634 16.1634 9 25 9ZM24.4991 31.722V31.222L24.4991 19.9846L20.9073 23.5764L20.5537 23.93L19.8466 23.2229L20.2002 22.8693L24.6455 18.424L24.9991 18.0704L25.3526 18.424L29.798 22.8693L30.1515 23.2229L29.4444 23.93L29.0908 23.5764L25.4991 19.9847L25.4991 31.222V31.722H24.4991Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopButton);
export default __webpack_public_path__ + "static/media/top-button.ce51523691875e9d6bf73968e30e5eaa.svg";
export { ForwardRef as ReactComponent };